import { ConfirmDialog } from '../../../../../../shared/components/ui/ConfirmDialog';
import { AccountAction } from '../../../../domain/models/AccountStatus';

interface AccountActionConfirmDialogProps {
  open: boolean;
  action: AccountAction;
  accountName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ACTION_MESSAGES: Record<'cancel' | 'remove', string> = {
  cancel: 'The Account will be canceled. Do you want to continue?',
  remove: 'The Account will be deleted. Do you want to continue?',
};

export function AccountActionConfirmDialog({
  open,
  action,
  accountName,
  onConfirm,
  onCancel,
}: AccountActionConfirmDialogProps) {
  const message =
    ACTION_MESSAGES[action as 'cancel' | 'remove'] ?? 'Are you sure you want to continue?';
  const title = `Confirm ${action.charAt(0).toUpperCase() + action.slice(1)}`;

  return (
    <ConfirmDialog
      open={open}
      title={title}
      description={
        <>
          <strong>{accountName}</strong>
          <br />
          {message}
        </>
      }
      confirmLabel="Continue"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
